import {Pipe, PipeTransform} from '@angular/core';
import * as moment from "moment";
import {TranslateService} from "@ngx-translate/core";
import {LanguageService} from '../service/language.service';
import {CommonService} from "../service/common.service";

@Pipe({
  name: 'dayAgo',
  pure: false,
  standalone: true
})
export class DayAgoPipe implements PipeTransform {

  constructor(private commonService: CommonService,
              private languageService: LanguageService) {
  }

  transform(date: string | Date, format: string = 'DD MMM', formatHours?: string): string {

    moment.locale(this.languageService.language);

    var now = moment().startOf('day');
    var dateMoment = moment(date);
    var dateStart = moment(date).startOf('day');

    var diffDays = now.diff(dateStart, 'days');

    const hours = formatHours ? dateMoment.format(formatHours) : '';

    return this.commonService.getDateTimeLabel(diffDays, hours, format, dateMoment);

  }
}
